/**
 * 路由配置文件
 * 懒加载: const Foo = () => import('./Foo.vue')
 * 嵌套路由：https://router.vuejs.org/zh/guide/essentials/nested-routes.html
 * 编程式导航：https://router.vuejs.org/zh/guide/essentials/navigation.html
 * 路由元信息：https://router.vuejs.org/zh/guide/advanced/meta.html
 */

import Vue from 'vue'
import Router from 'vue-router'
// 账号管理
const Admin = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/admin')
// 咨询管理
const ask = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/ask')
// 资讯管理
const Info = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/info')
// 新闻政务动态管理
const news = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/news')
// 通知公告管理
const notificatio = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/notificatio')
// 展会管理
const Party = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/party')
// 互贸服务指引管理
const trade = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/trade')
// 轮播图
const banners = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/banners')
// 服务管理
const servers = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/servers')
// 产品管理
const product = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/goods')
// 需求管理
const supply = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/supply')
const need = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/need')
// 行业分类管理
const businessType = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/businessType')
// 政策类型管理
const policyType = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/policyType')
const policyLine = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/policyLine')
const sendUnit = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/sendUnit')

const train = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/train')
// 政策类型
const policy = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/policy')

const courtship = () => import('@/pages/common/courtship')
const upAndDow = () => import('@/pages/common/upAndDow')


const cityVideo = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/cityVideo')
const indexVideo = () => import(/* webpackChunkName: "group-common" */ '@/pages/common/indexVideo')

const Dashboard = () => import(/* webpackChunkName: "group-common" */ '@/pages/home/Dashboard')

const xcm = () => import(/* webpackChunkName: "group-user" */ '@/pages/common/xcm')

// 出口网站
// 信息管理
// 轮播图 banner
const Banner = () => import(/* webpackChunkName: "group-shop" */ '@/pages/outlet/Banner')
// 分类管理 categories
const Categories = () => import(/* webpackChunkName: "group-shop" */ '@/pages/outlet/Categories')
// 商品管理
// 商品 goods
const Goods = () => import(/* webpackChunkName: "group-general" */ '@/pages/outlet/Goods')
// 备案管理 records
const Records = () => import(/* webpackChunkName: "group-general" */ '@/pages/outlet/Records')
// 订单
  // 全部订单 order
const OrderAll = () => import(/* webpackChunkName: "group-general" */ '@/pages/outlet/order/OrderAll')
  // 待付款 ordersUnpaid
const OrdersUnpaid = () => import(/* webpackChunkName: "group-order" */ '@/pages/outlet/order/OrdersUnpaid')
  // 待清关 ordersNoCustomhouse
const OrdersNoCustomhouse = () => import(/* webpackChunkName: "group-order" */ '@/pages/outlet/order/OrdersNoCustomhouse')
  // 已清关 ordersYesCustomhouse
const OrdersYesCustomhouse = () => import(/* webpackChunkName: "group-order" */ '@/pages/outlet/order/OrdersYesCustomhouse')
  // 待发货 OrdersWaitingCross
const OrdersWaitingCross = () => import(/* webpackChunkName: "group-order" */ '@/pages/outlet/order/OrdersWaitingCross')
  // 已发货 ordersSend
const OrdersSend = () => import(/* webpackChunkName: "group-order" */ '@/pages/outlet/order/OrdersSend')
// 用户
  // 用户管理 users
  const Users = () => import(/* webpackChunkName: "group-user" */ '@/pages/outlet/Users')
  // 商家入驻 Settled
  const Settled = () => import(/* webpackChunkName: "group-user" */ '@/pages/outlet/Settled')
// 系统管理
 // 管理员 branches
 const branches = () => import(/* webpackChunkName: "group-user" */ '@/pages/outlet/branches')


 

const load = () => import('@/pages/load')


Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Dashboard', component: Dashboard },
    { path: '/admin', name: 'admin', component: Admin },
    { path: '/ask', name: 'ask', component: ask },
    { path: '/info', name: 'info', component: Info },
    // 新闻政务动态管理
    { path: '/news', name: 'news', component: news },
    // 通知公告管理
    { path: '/notificatio', name: 'notificatio', component: notificatio },
    // 展会管理
    { path: '/party', name: 'party', component: Party },
    // 互贸服务指引管理
    { path: '/trade', name: 'trade', component: trade },
    { path: '/banners', name: 'banners', component: banners },
    // 服务管理 servers
    { path: '/servers', name: 'servers', component: servers },
    // 产品管理
    { path: '/product', name: 'product', component: product },
    { path: '/need', name: 'need', component: need },
    { path: '/supply', name: 'supply', component: supply },
    { path: '/businessType', name: 'businessType', component: businessType },
    { path: '/policyType', name: 'policyType', component: policyType },
    { path: '/policyLine', name: 'policyLine', component: policyLine },
    { path: '/sendUnit', name: 'sendUnit', component: sendUnit },

    { path: '/cityVideo', name: 'cityVideo', component: cityVideo },
    { path: '/indexVideo', name: 'indexVideo', component: indexVideo },
    
    { path: '/train', name: 'train', component: train },
    // 政策类型
    { path: '/policy', name: 'policy', component: policy },
    { path: '/courtship', name: 'courtship', component: courtship },
    { path: '/upAndDow', name: 'upAndDow', component: upAndDow },

    { path: '/xcm', name: 'xcm', component: xcm },
    
// 出口网站
// 信息管理
  // 轮播图 banner
  { path: '/banner', name: 'Banner', component: Banner },
  // 分类管理 categories
  { path: '/categories', name: 'Categories', component: Categories },
// 商品管理
  // 商品 goods
  { path: '/goods', name: 'Goods', component: Goods },
  // 备案信息 records
  { path: '/records', name: 'Records', component: Records },
// 订单
  // 全部订单
  { path: '/order', name: 'OrderAll', component: OrderAll },
  // 待支付
  { path: '/ordersUnpaid', name: 'OrdersUnpaid', component: OrdersUnpaid },
  // 待清关
  { path: '/ordersNoCustomhouse', name: 'OrdersNoCustomhouse', component: OrdersNoCustomhouse },
  // 已清关
  { path: '/ordersYesCustomhouse', name: 'OrdersYesCustomhouse', component: OrdersYesCustomhouse },
  // 待发货
  { path: '/OrdersWaitingCross', name: 'OrdersWaitingCross', component: OrdersWaitingCross },
  // 已发货
  { path: '/ordersSend', name: 'OrdersSend', component: OrdersSend },
// 用户
  // 用户管理
  { path: '/users', name: 'Users', component: Users },
  // 企业入驻
  { path: '/Settled', name: 'Settled', component: Settled },
// 系统管理
 // 管理员 branches
 { path: '/branches', name: 'branches', component: branches },

    // 加载页面
    { path: '/load', name: 'load/:role_business', component: load }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js